import { createContext, useContext } from 'react'
import type { AuthMode } from './auth-mode'

export interface DashboardUser {
  id: string
  email: string
  name: string | null
}

export interface DashboardAuthValue {
  authMode: AuthMode
  isAuthenticated: boolean
  isLoading: boolean
  user: DashboardUser | null
  signIn: (token?: string) => Promise<void>
  silentSignIn: () => Promise<void>
  signOut: () => Promise<void>
  getAccessToken: () => Promise<string | null>
}

export const DashboardAuthContext = createContext<DashboardAuthValue | null>(null)

export function useDashboardAuthContext() {
  const value = useContext(DashboardAuthContext)
  if (!value) {
    throw new Error('useAuth must be used within AuthProvider')
  }
  return value
}
